import { useSelector } from 'react-redux'
import _ from 'lodash'

import { useFilterTours } from './useFilterTours'
import { useSearchResults } from './useSearchResults'
import { getFilters } from '../redux/reducers/filters'

export function useGetFilteredToursWithException(exception) {
  const filterState = useSelector(getFilters)
  const tours = useSearchResults()

  const filterStateWithException = _.omit(filterState, exception)

  return useFilterTours(tours, filterStateWithException)
}
